/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {Button, SHAPE} from 'baseui/button'
import {Heading, HeadingLevel} from 'baseui/heading'
import React from 'react'
import {Link} from 'react-router-dom'
import {NoSidebarLayout} from '../../components/layout'
import {routes} from '../../utils/config'

const NoMatchWithAuth = () => (
  <NoSidebarLayout>
    <Block marginTop="scale800">
      <HeadingLevel>
        <Heading
          styleLevel={2}
          overrides={{
            Block: {
              style: ({$theme}) => ({
                color: $theme.colors.mono500,
                fontWeight: 900,
                textAlign: 'center',
              }),
            },
          }}
        >
          Sorry... But I think
          <br />
          you might be lost.
        </Heading>
      </HeadingLevel>
      <Block
        $as="img"
        src="/assets/images/character-cog.png"
        height="20rem"
        marginTop="scale1200"
        marginBottom="scale1200"
      />
      <Block display="flex" justifyContent="center" marginBottom="scale2400">
        <Button
          $as={Link}
          to={routes.home.url}
          shape={SHAPE.pill}
          overrides={{
            BaseButton: {
              style: ({$theme}) => ({
                background: $theme.colors.primary,
                color: $theme.colors.primary50,
                fontSize: 2.4 + 'rem',
                fontWeight: 900,
                paddingTop: $theme.sizing.scale800,
                paddingBottom: $theme.sizing.scale900,
                paddingLeft: $theme.sizing.scale1200,
                paddingRight: $theme.sizing.scale1200,
                ':hover': {
                  background: $theme.colors.primary500,
                  color: $theme.colors.primary200,
                },
              }),
            },
          }}
        >
          go home
        </Button>
      </Block>
    </Block>
  </NoSidebarLayout>
)

export default NoMatchWithAuth
